<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card class="mb-5">
      <v-card-title>
        <v-container>
          <v-row no-gutters>
            <v-col cols="12" md="2" class="mr-5 mb-1">
              Appointment
              <v-btn depressed small color="primary" append-icon="mdi-printer" v-on:click="printListAll">
                <v-icon>mdi-printer</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="2" sm="12" class="mr-5 mb-2">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="date"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4" sm="12" class="mr-5 mb-2 d-flex">
              <v-autocomplete
                  :items="doctors"
                  v-model="doctor_id"
                  item-text="dr_name"
                  item-value="id"
                  required
                  label="Doctor"
                  outlined
                  dense
                  chips
                  hide-details
              ></v-autocomplete>
              <v-btn class="ms-1" depressed color="warning" type="button"  @click="clearDoctor()">
                <v-icon>
                  mdi-minus-circle
                </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="3" sm="12" class="mr-5 mb-1 d-flex">
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Patient Details"
                  single-line
                  outlined
                  dense
                  hide-details
              ></v-text-field>
              <v-btn class="ms-1" depressed color="warning" type="button"  @click="clearSearch()">
                <v-icon>
                  mdi-minus-circle
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
    </v-card>
    <v-card>
      <v-container>
        <v-row no-gutters>

          <div class="statusClass">
            <v-btn
                :color="colorFound('Total')"
                class="status-filter-btn text-none mr-1 mt-1 mb-1"
                @click="searchStatus('Total')"
                small
                tonal
                stacked
            >
              <v-icon small>mdi-format-list-bulleted</v-icon>
              Total ({{ today_total_patient }})
            </v-btn>
            <v-btn
                v-for="(countStatusAppointment, index) in countStatusAppointments"
                :key="index"
                :color="colorFound(countStatusAppointment.waiting_status)"
                class="status-filter-btn text-none mr-1 mt-1 mb-1"
                @click="searchStatus(countStatusAppointment.waiting_status)"
                small
                tonal
                stacked
            >
                <v-icon v-if="countStatusAppointment.waiting_status === 'Cancel'" small color="red">mdi-delete-forever</v-icon>
                <v-icon v-else-if="countStatusAppointment.waiting_status === 'Waiting'" small>mdi-clock-start</v-icon>
                <v-icon v-else-if="countStatusAppointment.waiting_status === 'Done'" small color="success">mdi-clipboard-check</v-icon>
                <v-icon v-else-if="countStatusAppointment.waiting_status === 'Forward to investigation'|| countStatusAppointment.waiting_status === 'Investigation completed'" small color="blue">mdi-camera-gopro</v-icon>
                <v-icon v-else-if="countStatusAppointment.waiting_status === 'Rescheduled'" small color="red">mdi-redo-variant</v-icon>
                <v-icon v-else small>mdi-circle-outline</v-icon>
              {{ countStatusAppointment.waiting_status }} ({{ countStatusAppointment.total_patient }})
            </v-btn>
          </div>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col sm="12" md="12">
            <div style="font-size: 25px">{{ waiting_status ? waiting_status + '(' + waiting_status_total + ')' : '' }}</div>
          </v-col>
        </v-row>
      </v-container>
      <v-data-table
        :headers="headerCheck === 1 ? headers : headers2"
        :items="itemsWithSno"
        class="elevation-1"
        dense
        mobile-breakpoint="0"
        :loading="loadingstatus"
        loading-text="Loading... Please wait"
    >
      <template v-slot:item.time_slot="{ item }">
        <v-btn small color="success" class="mt-2" style="padding: 3px; height: 30px">
          {{ item.time_slot }}
        </v-btn>
        <p class="">Q-ID:{{ item.id }}</p>
      </template>
      <template v-slot:item.serial_no="{ item }">
        <v-btn small color="warning">
          {{ item.serial_no }}
        </v-btn>
      </template>
      <template v-slot:item.patient_details="{ item }">
        <div>
          {{ item.patient.patient_id }}<br>
          <div @click="editPatientInfo(item.patient.patient_id)" class="" style="cursor: pointer">
            <v-icon> mdi-tooltip-edit</v-icon>
            <span style="font-weight: bold">{{ item.patient.patient_name }}</span>
          </div>
          {{ item.patient.patient_phone }}
        </div>
      </template>
        <template v-slot:item.invoice_created="{ item }">
          <div v-if="item.paid_consultation_invoice">
               {{ formatTime(item.paid_consultation_invoice.created_at) }}
          </div>
      </template>
      <template v-slot:item.birthday_date="{ item }">
        <div v-if="item.patient.dob_not_known_check !== 1">
        {{ item.patient.patient_dob }}<br>
        </div>
        <v-btn v-if="item.patient.dob_not_known_check === 1" small color="red" style="color: white">
            Not Verified
        </v-btn>
      </template>
      <template v-slot:item.waiting_status="{ item }">
        <div v-if="item.waiting_status === 'Cancel'">
          <v-chip color="error" small>
            {{ item.waiting_status }}
          </v-chip>
          <br>
          <span><b>Cancel note:</b> {{ item.cancel_note }}</span><br>
          <span v-if="item.cancel_user"><b>Cancel By:</b> {{ item.cancel_user.full_name }}</span>
        </div>
        <div v-else-if="item.waiting_status === 'Rescheduled'">
          <v-chip color="grey" small>
            {{ item.waiting_status }}
          </v-chip>
          <br>
          <span><b>Reschedule Note:</b> {{ item.cancel_note }}</span><br>
          <span v-if="item.cancel_user"><b>Rescheduled By:</b> {{ item.cancel_user.full_name }}</span>
        </div>
        <div v-else-if="item.waiting_status === 'Pending'">
          <div class="d-flex">
            <v-btn stacked small color="" outlined>
              {{ item.waiting_status }}
            </v-btn>
            <v-btn class="mx-2" small color="error" @click="cancelStatusModal('Cancel', item.id)">
              Cancel ?
            </v-btn>
            <v-btn small color="error" @click="reschedule(item.patient_id,item.id,item.doctor_id)">
              RS ?
            </v-btn>
          </div>
        </div>
        <div v-else-if="item.waiting_status === 'Done'">
          <v-btn stacked small color="success">
            {{ item.waiting_status }}
          </v-btn>
        </div>
        <div v-else>
          <div class="d-flex">
          <v-btn small color="primary">{{ item.waiting_status }}</v-btn>
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-2" small v-bind="attrs" v-on="on" color="cyan">
                <v-icon dark small>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>

            <div v-if="item.waiting_status !== 'Pending'">
              <v-list>
                <v-list-item v-for="(status, i) in changeAppointmentStatuses" :key="i"
                             @click="changeStatus(status.value, item.id)">
                  <v-list-item-title>{{ status.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </div>
          </v-menu>
          </div>
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <div v-if="!['Cancel', 'Rescheduled'].includes(item.waiting_status)">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="create_new_prescription(item.patient_id, item.id)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  prepend-icon="mdi-printer"
                  color="primary"
                  label
                  outlined
                  small
              >
                <v-icon left> mdi-prescription</v-icon>
              </v-chip>
            </template>
            <span>New Prescription</span>
          </v-tooltip>
          <v-btn small color="primary" @click="openCreateInvoiceModal(item)">Create Invoice</v-btn>
          <div v-if="item.appointment_note">
            <v-btn class="mt-1" small color="warning" @click="openCreateInvoiceModal(item)"><v-icon>mdi-eye</v-icon>View Note</v-btn>
          </div>
        </div>
        <span style="font-size: 10px" v-if="item.user">Created By: {{ item.user.full_name }}</span> <span v-if="item.agent_info" style="font-size: 10px"> {{ '('+item.agent_info+')' }}</span>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    </v-card>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="750">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2"> Appointment Details [{{ createInvoiceModal.appointment_id }}]
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row no-gutters class="mt-1">
                  <v-col md="3"><p style="color: black">Serial No</p></v-col>
                  <v-col md="3">
                    <v-btn small color="warning">{{ createInvoiceModal.serial_no }}</v-btn>
                  </v-col>
                  <v-col md="3"><p style="color: black">Date & Time</p></v-col>
                  <v-col md="3">
                    <v-btn small color="success" class=" mr-2" style="padding: 3px; height: 30px">{{ createInvoiceModal.appointment_date }}</v-btn>
                    <v-btn small color="success" class="" style="padding: 3px; height: 30px">{{ createInvoiceModal.time_slot }}</v-btn>
                  </v-col>
                  <v-col md="3"><p style="color: black">Appointment Note</p></v-col>
                  <v-col md="9"><p style="color: black">{{ createInvoiceModal.appointment_note }}</p></v-col>
                </v-row>

                <h3 class="mt-1" style="color: black">Patient Information</h3>
                <v-row no-gutters class="mt-1">
                  <v-col md="3"><p style="color:black;">Patient ID</p></v-col>
                  <v-col md="4" class="mr-1">
                    <v-text-field
                        v-model="createInvoiceModal.patient_id"
                        outlined
                        :disabled="disabledPatientId"
                    ></v-text-field>
                  </v-col>
                  <v-col md="3">
                    <div v-if="createInvoiceModal.waiting_status == 'Pending'">
                      <v-btn color="primary" @click="updateNewPatientId(createInvoiceModal.appointment_id)"> Update</v-btn>
                    </div>
                  </v-col>
                  <v-col md="3"><p style="color:black;">Name</p></v-col>
                  <v-col md="9">
                    <p style="color:black;">{{ createInvoiceModal.patient_name }}</p>
                    <v-btn small color="success" class="mr-1">{{ createInvoiceModal.patient_phone }}</v-btn>
                    <v-btn small color="success" class="mr-1">{{ createInvoiceModal.patient_dob }}</v-btn>
                    <v-btn small color="success" class="mr-1">{{ createInvoiceModal.patient_sex }}</v-btn>
                    <v-btn small color="warning" @click="editPatientInfo(createInvoiceModal.patient_id)" class="mr-1"><v-icon left> mdi-tooltip-edit</v-icon> Edit Patient Info</v-btn>
                  </v-col>
                </v-row>
                <h3 class="mt-1" style="color: black">Doctor Information</h3>
                <v-row no-gutters class="mt-1">
                  <v-col md="3"><p style="color:black;">Doctor Name</p></v-col>
                  <v-col md="9"><p style="color:black;"><b>{{ createInvoiceModal.doctor_name }}</b>{{ createInvoiceModal.doctor_id }}</p></v-col>
                  <v-col md="3"><p style="color:black;">Doctor Designation</p></v-col>
                  <v-col md="9"><p style="color:black;"><span style=" line-height: 0.5;" v-html="createInvoiceModal.doctor_designation">
                    {{ createInvoiceModal.doctor_designation }}</span></p></v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="" outlined @click="dialog = false"><v-icon>mdi-close</v-icon> Close</v-btn>
              <v-btn small color="primary" @click="create_consultation_invoice(createInvoiceModal)"><v-icon>mdi-account-check</v-icon> Invoice Consultation</v-btn>
<!--              <v-btn small color="warning" @click="create_invoice_opd(createInvoiceModal)"><v-icon>mdi-plus-outline</v-icon> Invoice OPD</v-btn>-->
              <v-btn small color="secondary" @click="create_invoice_investigation(createInvoiceModal)"><v-icon>mdi-account-search</v-icon> Invoice Investigation</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

    </template>
  </div>
</template>
<style scoped>
.statusClass {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}

.status-filter-btn.v-btn {
  font-size: 11px !important;
  min-height: 52px !important;
  height: auto !important;
  min-width: 88px;
  padding: 4px 8px !important;
}
</style>
<script>
import atshq from "../../../js/setup";
import moment from "moment/moment";

export default {
  data() {
    return {
      dialog: false,
      date: moment().format('YYYY-MM-DD'),
      menu2: false,
      loadingstatus: true,
      returnAppUrl: atshq.defaults.headers.common.app_URL,
      returnBaseUrl: atshq.defaults.headers.common.base_URL,
      returnApiBaseURL: atshq.defaults.headers.common.api_base_URL,
      login_user_id: localStorage.getItem("userId"),
      filter_status: 'Total',
      search: "",
      headerCheck: 1,
      headers: [
        {text: "#", value: "sno",},
        {text: "Time", value: "time_slot"},
        {text: "Serial", value: "serial_no"},
        {text: "Patient Details", value: "patient_details",},
        {text: "Arrived at", value: "invoice_created",},
        {text: "Date of Birth", value: "birthday_date",},
        {text: "Doctor", value: "doctor.dr_name"},
        {text: "Availability", value: "waiting_status"},
        {text: "Action", value: "actions", sortable: false},
      ],
      headers2: [
        {text: "#", value: "sno",},
        {text: "Time", value: "time_slot"},
        {text: "Serial", value: "serial_no"},
        {text: "Patient Details", value: "patient_details",},
        {text: "Arrival Time", value: "invoice_created",},
        {text: "Date of Birth", value: "birthday_date",},
        {text: "Availability", value: "waiting_status"},
        {text: "Action", value: "actions", sortable: false},
      ],
      desserts: [],
      doctors: [],
      countStatusAppointments: [],
      doctor_id: '',
      today_total_patient: 0,
      waiting_status: 'Total',
      waiting_status_total: 0,
      changeAppointmentStatuses: [
        {text: '-', value: ''},
        {text: 'Forward to investigation', value: 'Forward to investigation'},
        {text: 'Investigation completed', value: 'Investigation completed'},
        {text: 'Done', value: 'Done'},
      ],
      change_appointment_status_name: '',
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Appointment",
          disabled: true,
          href: "appointment",
        },
      ],
      disabledPatientId: true,
      createInvoiceModal: {
        id: '',
        waiting_status: '',
        appointment_id: '',
        appointment_date: '',
        time_slot: '',
        time: '',
        appointment_note: '',
        patient_id: '',
        patient_name: '',
        patient_phone: '',
        patient_dob: '',
        patient_sex: '',
        doctor_name: '',
        doctor_id: '',
        app_doctor_id: '',
        doctor_designation: '',
      }
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize(this.date, this.doctor_id);
  },
  watch: {
    doctor_id() {
      this.loadingstatus = true;
      this.waiting_status = 'Total';
      this.filter_status = 'Total';
      if (this.doctor_id) {
        this.headerCheck = 0
      } else {
        this.headerCheck = 1;
      }
      this.initialize()
    },
    waiting_status() {
      this.loadingstatus = true;
      this.filter_status = this.waiting_status
      this.initialize()
    },
    date() {
      this.loadingstatus = true;
      this.doctor_id = '';
      this.waiting_status = 'Total';
      this.filter_status = 'Total';
      this.search = '';
      this.initialize()
    },
    search(){
      this.initialize()
    }
  },
  computed: {
    itemsWithSno() {
      return this.desserts.map((d, index) => ({...d, sno: index + 1}));
    },
  },
  methods: {
    initialize() {
      if (!this.waiting_status) {
        this.waiting_status = 'Total';
        this.filter_status = 'Total';
      }
      if (this.doctor_id === undefined) {
        this.doctor_id = ''
      }
      atshq
          .get("appointments/appointments?date=" + this.date + '&waiting_status=' + this.waiting_status + '&doctor_id=' + this.doctor_id + '&search=' + this.search)
          .then((response) => {
            this.loadingstatus = false;
            this.desserts = response.data.appointments;
            console.log(response.data.appointments[0]);
            this.doctors = response.data.doctors;
            this.countStatusAppointments = response.data.countStatusAppointments;
            if (this.waiting_status === 'Total') {
              this.waiting_status_total = response.data.total_patient
            } else if ((this.countStatusAppointments).length > 0) {
              this.waitingStatusTotalCalculation(this.countStatusAppointments)
            }
            this.today_total_patient = response.data.total_patient
          })
          .catch((e) => {
            this.$noty.error(e);
          });
    },
    waitingStatusTotalCalculation(countStatusAppointments) {
      countStatusAppointments.forEach((item) => {
        if (item.waiting_status === this.waiting_status) {
          this.waiting_status_total = item.total_patient
        }
      });
    },
    create_consultation_invoice(item) {
      if (item.patient_id && item.app_doctor_id && item.appointment_id) {
        window.location.href = "/invoice/invoice-create-consultancy" + "?patient_id=" + item.patient_id + '&type=consultation' + '&doctor=' + item.app_doctor_id + '&appointment_id=' + item.appointment_id;
      } else {
        this.$noty.error('Data is not Found')
      }
    },
    create_invoice_investigation(item) {
      if (item.patient_id && item.app_doctor_id && item.appointment_id) {
          window.location.href = "/invoice/invoice-create-investigation/" + item.patient_id;
          // window.open(this.returnAppUrl + "front_desk/invoice" + "?patient_id=" + item.patient_id);
          this.dialog = false
      } else {
        this.$noty.error('Data is not Found')
      }
    },
      create_invoice_opd(item) {
      if (item.patient_id && item.app_doctor_id && item.appointment_id) {
        window.location.href = "/invoice/opd-invoice-create/"+ item.id;
          this.dialog = false
      } else {
        this.$noty.error('Data is not Found')
      }
    },
    printListAll() {
      if (!this.doctor_id) {
        this.$noty.error('Sorry! Please Select Doctor ID');
        return
      }
      window.open(this.returnApiBaseURL + "print/appointment-list?doctor_id=" + this.doctor_id + '&date=' + this.date + '');
    },
    cancelStatusModal(waiting_status, appointment_id) {
      this.$swal.fire({
        text:'Please type your cancel note',
        input:'text',
        confirmButtonText: 'Submit',
        showCancelButton: true,
        preConfirm:(textValue) => {
          return atshq
              .post('appointments/appointment-status-change/' + appointment_id, {
                waiting_status: waiting_status,
                cancel_note: textValue,
                login_user_id: this.login_user_id,
              })
              .then(response => {
                this.loadingstatus = true;
                this.initialize(this.date, this.doctor_id, this.waiting_status)
                this.$noty.success(response.data.message);
              })
              .catch((e) => {
                this.loadingstatus = true;
                this.initialize(this.date, this.doctor_id, this.waiting_status)
                this.$swal.showValidationMessage( `${e.response.data.message}`  )
              });
        }
      }).then((response) => {
        if (response.isConfirmed) {
          this.loadingstatus = true;
          this.initialize(this.date, this.doctor_id, this.waiting_status)
        }
      });
    },
    changeStatus(waiting_status, appointment_id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!'
      }).then((result) => {
        if (result.value) {
          atshq
              .post('appointments/appointment-status-change/' + appointment_id, {
                waiting_status: waiting_status,
                login_user_id: this.login_user_id,
              })
              .then(response => {
                this.loadingstatus = true;
                this.initialize(this.date, this.doctor_id, this.waiting_status)
                this.$noty.success(response.data.message);
              })
              .catch((e) => {
                this.$noty.error(e.response.data.message);
                this.loadingstatus = true;
                this.initialize(this.date, this.doctor_id, this.waiting_status)
              });
        }
      });
    },
    openCreateInvoiceModal(item) {
      this.dialog = true;
      if (item.waiting_status === 'Pending') {
        this.disabledPatientId = false
      } else {
        this.disabledPatientId = true
      }
      this.createInvoiceModal.id = item.id
      this.createInvoiceModal.waiting_status = item.waiting_status
      this.createInvoiceModal.appointment_id = item.id
      this.createInvoiceModal.serial_no = item.serial_no
      this.createInvoiceModal.appointment_date = item.appointment_date
      this.createInvoiceModal.time_slot = item.time_slot
      this.createInvoiceModal.appointment_note = item.appointment_note
      this.createInvoiceModal.patient_id = item.patient_id
      this.createInvoiceModal.patient_name = item.patient.patient_name
      this.createInvoiceModal.patient_phone = item.patient.patient_phone
      this.createInvoiceModal.patient_dob = item.patient.patient_dob
      this.createInvoiceModal.patient_sex = item.patient.patient_sex
      this.createInvoiceModal.doctor_name = item.doctor.dr_name
      this.createInvoiceModal.doctor_id = ' [' + item.doctor.dr_id + ']'
      this.createInvoiceModal.app_doctor_id = item.doctor_id
      this.createInvoiceModal.doctor_designation = item.doctor.dl_designation
    },
    editPatientInfo(patient_id) {
      window.open(this.returnBaseUrl + "patient-create/" + patient_id);
    },
    updateNewPatientId(appointment_id) {
      atshq
          .put('appointments/appointments/' + appointment_id, {
            patient_id: this.createInvoiceModal.patient_id,
            login_user_id: this.login_user_id,
          })
          .then(response => {
            this.loadingstatus = true;
            this.initialize(this.date, this.doctor_id, this.waiting_status)
            this.$noty.success(response.data.message);
            this.openCreateInvoiceModal(response.data.appointment)
          })
          .catch((e) => {
            this.$noty.error(e.response.data.message);
            this.loadingstatus = true;
            this.initialize(this.date, this.doctor_id, this.waiting_status)
          });
    },
    searchStatus(status) {
      this.waiting_status = this.filter_status = status
    },
    colorFound(waiting_status) {
      if (this.filter_status === waiting_status) {
        return 'success';
      } else {
        return null;
      }
    },
    clearDoctor() {
      this.doctor_id = '';
    },clearSearch() {
      this.search = '';
    },
    create_new_prescription(patient_id, appointment_id) {
      window.open(this.returnAppUrl + "prescription/treatment/new/" + patient_id + '/null/' + appointment_id);
    },
    formatTime(value){
        return moment(value).format('hh:mm A')
    },
    reschedule(patient_id, appointment_id,doctor_id){
      window.open(this.returnBaseUrl + "appointment/create/" + patient_id+"?appointment_id="+appointment_id+"&status=reschedule"+"&doctor_id="+doctor_id);
    },
  },
};
</script>